import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-067e9c39")

_pushScopeId("data-v-067e9c39")
const _hoisted_1 = { class: "dhm_bottom" }
const _hoisted_2 = { class: "dhm_content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "welcome_title" }, "欢迎加入可牛会员", -1)
const _hoisted_4 = { class: "dhm_input flex_centers" }
const _hoisted_5 = { class: "exchange_action flex_centers" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "rule_box" }, [
  /*#__PURE__*/_createVNode("span", null, "规则说明"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "1、登录可牛账号后，输入兑换码即可兑换。 "),
    /*#__PURE__*/_createVNode("li", null, "2、请在领取时注意兑换码有效期，过期作废，不可退款。"),
    /*#__PURE__*/_createVNode("li", null, "3、此兑换码严禁转卖，不可兑换现金，遗失泄露等不补。 "),
    /*#__PURE__*/_createVNode("li", null, "4、权益功能详情请在会员中心页面查看。")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModel.code = $event)),
          placeholder: "请输入兑换码"
        }, null, 512), [
          [_vModelText, _ctx.viewModel.code]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", {
          class: "go_exchange",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goExchange && _ctx.goExchange(...args)))
        }, "立即兑换")
      ])
    ]),
    _hoisted_6
  ]))
})